import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/axiosConfig";
import { DELETE_CAR } from "../../constant-value";

// AsyncThunk برای حذف ماشین
export const deleteCar = createAsyncThunk(
  "carDelete/deleteCar",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${DELETE_CAR}${id}`);
      return id; // برگردوندن id ماشین حذف شده
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const carDelSlice = createSlice({
  name: "carDelete",
  initialState: {
    isLoading: false,   // آیا عملیات در حال انجام است
    isSuccess: false,   // آیا حذف موفق بود
    error: null,        // خطا در حذف
  },
  reducers: {
    // ریست کردن state بعد از استفاده
    resetDeleteState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCar.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(deleteCar.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(deleteCar.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload || "خطا در حذف خودرو";
      });
  },
});

// اکشن‌ها
export const { resetDeleteState } = carDelSlice.actions;

// سلکتورها
export const selectDelLoadingState = (state) => state.carDelete.isLoading;
export const selectDelSuccessState = (state) => state.carDelete.isSuccess;
export const selectDelErrorState = (state) => state.carDelete.error;

export default carDelSlice.reducer;
